import { Box } from '@pets-ui/Box/Box'
import { type WordPressMobileMediaQuery } from '@pets-ui/tokens/breakpoints.stylex'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const WORDPRESS_MOBILE: WordPressMobileMediaQuery = '@media (max-width: 960px)'

const styles = stylex.create({
  card: {
    padding: '10px 12px',
    borderRadius: 8,
    alignItems: 'center',
    backgroundColor: colors.white,
    display: 'flex',
    justifyContent: 'center',
    marginTop: 8,
    minHeight: {
      [WORDPRESS_MOBILE]: '188px',
      default: '96px',
    },
    width: '100%',
  },
})

interface OrderEmptyCardProps {
  children?: ReactNode
}
export function OrderEmptyCard({ children }: OrderEmptyCardProps) {
  return (
    <Box {...stylex.props(styles.card)}>
      {children}
    </Box>
  )
}
